export const adrActionsFactory = ['$interval', adrActions];

function adrActions($interval) {
    var directive = {
        restrict: 'E',
        templateUrl: 'js/actions.directive.html',
        scope: {
            taskActions: '=',
            filterText: '@',
            filterInput: '=',
            onAction: '&',
        },
        controller: ['$scope', '$filter', ActionsController],
        controllerAs: 'vm',
        bindToController: true,
    };

    return directive;

    function ActionsController($scope, $filter) {
        var checkActionsInterval;

        $scope.vm.filterActions = function () {
            $scope.vm.filteredActions = $filter('filter')(
                $scope.vm.taskActions,
                $scope.vm.filterText ? $scope.vm.filterText : $scope.vm.filterInput
            );
        };

        $scope.$watch('vm.filterInput', function (value) {
            // console.log('watch: vm.filterInput %s', value);
            $scope.vm.filterActions();
        });

        $scope.vm.checkActions = function () {
            if ($scope.vm.filteredActions && $scope.vm.filteredActions.length) {
                // console.log('filterText = "%s" - count = %s',
                // $scope.vm.filterText,
                // $scope.vm.filteredActions.length);

                $interval.cancel(checkActionsInterval);
            } else {
                // console.log('filteredActions empty');
                $scope.vm.filterActions();
            }
        };

        //
        $scope.vm.expandInput = function (e) {
            if (e.currentTarget.style.width != '200px') {
                e.currentTarget.style.width = '200px';
            }
        };

        checkActionsInterval = $interval($scope.vm.checkActions, 800, 1);
    }
}
